import { EventEmitter } from 'events';
import NotificationSystem from "react-notification-system";


type TMesagePosition = "tr" | "tl" | "tc" | "br" | "bl" | "bc";


class CommonService {

  public redirectAfterLogin: string;

  public emitter: EventEmitter;
  public notificationSystem: NotificationSystem.System;
  private _router: any;

  constructor() {
    this.emitter = new EventEmitter();
  }

  emit(event: any, ...params: any[]) {
    this.emitter.emit(event, params);
  }

  loading(isOn: boolean) {
    this.emit("LOADING", isOn);
  }



  notifyError(message: string, title: string, children?: any, autoDismiss: number = 5) {
    if (this.notificationSystem) {
      this.notificationSystem.addNotification({
        title: (title) ? title : 'Error',
        message,
        position: 'tr',
        autoDismiss,
        level: 'error',
        children
      });
    }
  }

  notifySuccess(message: string, title?: string, children?: any, autoDismiss: number = 5, position: TMesagePosition = 'br') {
    if (this.notificationSystem) {
      this.notificationSystem.addNotification({
        title: (title) ? title : 'Success',
        message,
        position,
        autoDismiss,
        level: 'success',
        children
      });
    }
  }

  notifyInfo(message: string, title?: string, children?: any, autoDismiss: number = 5) {
    if (this.notificationSystem) {
      this.notificationSystem.addNotification({
        title: (title) ? title : 'Info',
        message,
        position: 'br',
        autoDismiss,
        level: 'info',
        children
      });
    }
  }

  notifyWarning(message: string, title?: string, children?: any, autoDismiss: number = 5) {
    if (this.notificationSystem) {
      this.notificationSystem.addNotification({
        title: (title) ? title : 'Warning',
        message,
        position: 'br',
        autoDismiss,
        level: 'warning',
        children
      });
    }
  }

  get router() {
    return this._router;
  }

  set router(router) {
    this._router = router;
  }

}

const commonService = new CommonService();
export default commonService;




// WEBPACK FOOTER //
// ./src/core/common/service/commonService.ts